import { render, staticRenderFns } from "./PublicKnowledge.vue?vue&type=template&id=52646954&scoped=true&"
import script from "./PublicKnowledge.vue?vue&type=script&lang=js&"
export * from "./PublicKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./PublicKnowledge.vue?vue&type=style&index=0&id=52646954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52646954",
  null
  
)

export default component.exports